/* eslint-disable react/prop-types */
import styles from './AICard.less';

const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const AICard = ({
  header,
  content,
  gradientColor1 = '#02D5E2',
  gradientColor2 = '#5E90F0',
  gradientColor3 = '#BC78E6',
  gradientColor4 = '#F65E83',
}) => {
  const cardStyle = {
    '--gradient-color1': gradientColor1,
    '--gradient-color2': gradientColor2,
    '--gradient-color3': gradientColor3,
    '--gradient-color4': gradientColor4,
    '--gradient-color1-faint': hexToRgba(gradientColor1, 0.3),
    '--gradient-color2-faint': hexToRgba(gradientColor2, 0.3),
    '--gradient-color3-faint': hexToRgba(gradientColor3, 0.3),
    '--gradient-color4-faint': hexToRgba(gradientColor4, 0.3),
    '--gradient-color1-bg': hexToRgba(gradientColor1, 0.1),
    '--gradient-color2-bg': hexToRgba(gradientColor2, 0.1),
    '--gradient-color3-bg': hexToRgba(gradientColor3, 0.1),
    '--gradient-color4-bg': hexToRgba(gradientColor4, 0.1),
  };

  return (
    <div className={styles.cardContainer} style={cardStyle}>
      <div className={styles.cardHeader}>{header}</div>
      <div className={styles.cardContent}>{content}</div>
    </div>
  );
};

export default AICard;
